import { selectors } from '@amplement/backend-connector';
import { createSelector } from 'reselect';
import { getCurrentUserIdSelector } from './user';

export const getAwayRoomMemberIdsWithoutMyUserByRoomIdSelector = createSelector(
    [selectors.rooms.getAwayRoomMemberIdsByRoomIdSelector, getCurrentUserIdSelector],
    (_members, _user) => _members?.filter(x => x !== _user)
);

export const getRoomFeatures = createSelector(
    [selectors.rooms.getRoomByIdSelector],
    (room) => room?.features
);


export const getRoomPhoneNumbers = createSelector([selectors.rooms.getRoomByIdSelector], (room) => {
    if (!room) {
        return {}
    }
    let callee;
    let caller;
    room?.members.forEach(member => {
        if (member.isCaller) {
            caller = member;
        }
        if (!member.isCaller) {
            if (!callee) {
                callee = member;
            } else if (callee?.joinedAt > member?.joinedAt) {
                callee = member;
            }
        }
    });

    if (caller.isMe) {
        return {
            phonenumber: callee?.phonenumber,
            displayablePhonenumber: callee?.displayablePhonenumber,
        }
    }
    return {
        phonenumber: caller?.phonenumber,
        displayablePhonenumber: caller?.displayablePhonenumber,
    }
})
